<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-11 14:33:43
 * @LastEditTime: 2023-05-10 14:51:29
 * @Description:
 * @FilePath: \website\src\App.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div id="app">
    <TopHead></TopHead>
    <div style="width: 90vw;  height: 30px;"></div>
    <router-view />
    <div style="width: 90vw;  height: 324px;"></div>
    <BottomFoot></BottomFoot>
  </div>
</template>

<script>
import TopHead from "./components/TopHead.vue";
import BottomFoot from "./components/BottomFoot.vue";
export default {
  components: { TopHead, BottomFoot },
  name: "App",
  data() {
    return {};
  },
};
</script>

<style>
#app {
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue